export default "/app-page/javascript/public/images/pin-blue-ecf0a7d3ab3e875d.png"